'use-strict';

import angular from 'angular';
import { Comment, ECommentContext } from '../../src/app/@shared-types/misc/comment';
import { UserRole } from '../../src/app/@types/user';
import { ApiService } from '../../src/app/shared/services/api';

export class CommentAPIService {
  private apiService: ApiService;

  constructor(
    apiService: ApiService,
  ) {
    'ngInject';

    this.apiService = apiService;
  }

  public getByContext = (
    context: ECommentContext, contextId: string,
  ): Promise<Comment[]> => this.apiService.get<Comment[]>(`/api/comments/${context}/${contextId}`);

  public postComment = (
    context: ECommentContext,
    contextId: string,
    comment: Partial<Comment>,
  ): Promise<number> => this.apiService.post<number>(`/api/comments/${context}/${contextId}`, comment);

  public deleteComment = (
    commentId: number,
  ): Promise<void> => this.apiService.delete<void>(`/api/comments/${commentId}`);
}

export default angular.module('services.commentApiService', [])
  .service('commentApiService', CommentAPIService)
  .name;
